import { CompanyBrandingModel } from "services/api/cplauthapi/CPLAuthAPI";
import { INewCompanyBrandingModel, NewCompanyBrandingModel } from "./NewCompanyBrandingModel";

/* eslint @typescript-eslint/no-explicit-any: 0 */
export interface IUpdateCompanyBrandingModel extends INewCompanyBrandingModel {
  companyBrandingID?: number;
  clientPortalName?: string;
  faviconUrl?: string | undefined;
  logoUrl?: string | undefined;
  bodyFontUrl?: string | undefined;
  headerFontUrl?: string | undefined;
  companyBrandingFileUrl?: string | undefined;
}

export class UpdateCompanyBrandingModel extends NewCompanyBrandingModel implements IUpdateCompanyBrandingModel {
  companyBrandingID?: number;
  faviconUrl?: string | undefined;
  logoUrl?: string | undefined;
  bodyFontUrl?: string | undefined;
  headerFontUrl?: string | undefined;
  companyBrandingFileUrl?: string | undefined;

  constructor(data?: IUpdateCompanyBrandingModel) {
    super();
    if (data) {
      for (const property in data) {
        if (Object.hasOwn(data, property)) (this as any)[property] = (data as any)[property];
      }
    }
  }
}

export function GenerateUpdateModelFromBranding(model: CompanyBrandingModel): UpdateCompanyBrandingModel {
  return new UpdateCompanyBrandingModel({
    ...model,
    isHeaderTextBold: model?.isHeaderTextBold ?? false,
    isHeaderTextItalic: model?.isHeaderTextItalic ?? false,
    isHeaderTextUnderlined: model?.isHeaderTextUnderlined ?? false,
  });
}
